export default __webpack_public_path__ + "static/media/wordpress-colored.79f83587.svg";